import React from 'react';
import PropTypes from 'prop-types';
import UserContext from './UserContext';
import { fetchUser } from '../../api/storefront';

/**
 * The context is just the UserProvider state object keyed on user.
 * For use when using HOC.
 */
export const userContextPropType = {
  user: PropTypes.shape({}),
};

/**
 * The context is just the UserProvider state object.
 * For use when using HOC.
 */
export const userContextDefaultProp = {
  user: undefined,
};

export default class UserProvider extends React.Component {
  constructor(props) {
    super(props);
    /**
     * User is initially undefined. This is used to indicate a pending request.
     * When user is defined, that means the request is finished.
     * It will be an empty object if no user.
     * It will be an object with user info if logged in.
     */
    this.state = {
      user: undefined,
    };
  }

  componentDidMount() {
    this.getUser();
  }

  async getUser() {
    try {
      const user = await fetchUser();
      if (user && !user.errors) {
        this.setState({
          user,
        });
      } else {
        this.setState({
          user: {},
        });
      }
    } catch (e) {
      this.setState({
        user: {},
      });
    }
  }

  setUser(user) {
    this.setState({ user });
  }

  render() {
    const { user } = this.state;
    return (
      <UserContext.Provider
        value={{ user }}>
        {/* eslint-disable-next-line react/destructuring-assignment */}
        {this.props.children}
      </UserContext.Provider>
    );
  }
}

UserProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
